/* eslint-disable new-cap */
import jsPDF from 'jspdf';
import { abrirPopup } from '~/pages/PdvOnline/utils/abrirPopup';

export const gerarCupomCaixa = (
  receipt: string,
  action: 'open' | 'send',
  cupom_name?: string,
): void | FormData => {
  const lineSpacing = 4;
  const margin = 20; // mm
  const pageWidth = 79;
  const lines = receipt.split('\n');

  const pageHeight = lines.length * lineSpacing + margin;

  const doc = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: [pageWidth, pageHeight],
  });

  doc.setFont('Courier');
  doc.setFontSize(7.2);
  doc.setTextColor(0, 0, 0);

  lines.forEach((line, idx) => {
    const contentAreaWidth = 73;
    const marginLeft = (pageWidth - contentAreaWidth) / 2;
    const y = 10 + idx * lineSpacing;

    const divisor = 'BAIRRO:';
    const divisorIndex = lines.findIndex((l) => l.trim() === divisor);

    let x;

    if (idx < divisorIndex) {
      const textWidth = doc.getTextWidth(line);
      x = marginLeft + (contentAreaWidth - textWidth) / 2;
    } else {
      x = marginLeft;
    }

    doc.setTextColor(0, 0, 0);
    doc.text(line, x, y);
  });

  const pdfBlob = doc.output('blob');

  if (action === 'open') {
    const pdfURL = URL.createObjectURL(pdfBlob);
    abrirPopup(pdfURL);
    // window.open(pdfURL, '_blank');
  } else if (action === 'send' && cupom_name) {
    const formData = new FormData();
    formData.append('file', pdfBlob, `${cupom_name}.pdf`);
    return formData;
  }
};
